import * as React from 'react';
import { SVGProps } from 'react';

const SvgIcGuideLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.5 3.75h21v16.5h-21V3.75Zm19.5 15V5.25h-4v13.5h4Zm-5.5 0V5.25H3v13.5h12.5Zm5.5-6v-1.5h-4v1.5h4ZM21 15v1.5h-4V15h4Zm0-6V7.5h-4V9h4Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIcGuideLeft;
